function closePreModal(e, modalMessage, modalOverlay) {
  e.preventDefault();
  modalMessage.classList.add("none");
  modalMessage.classList.remove("active");
  modalOverlay.classList.add("hidden");
}

const preorderModalMessage = document.querySelector(".preorder-modal-message");

if (preorderModalMessage !== null) {
  const preorderModalTriggers = document.querySelectorAll(
    ".preorder-modal-trigger",
  );
  const preorderModalOverlay = document.querySelector(
    ".preorder-modal-overlay",
  );
  const preorderModalClose = document.querySelector(".preorder-modal-close");
  const preorderModalCloseImg = document.querySelector(
    ".preorder-modal-close img",
  );

  preorderModalTriggers.forEach((trigger) => {
    trigger.addEventListener("click", (e) => {
      if (
        e.target === preorderModalClose ||
        e.target === preorderModalCloseImg ||
        e.target.tagName === "A"
      ) {
        return;
      }
      e.preventDefault();
      preorderModalMessage.classList.remove("none");
      preorderModalMessage.classList.add("active");
      preorderModalOverlay.classList.remove("hidden");
    });
  });

  preorderModalClose.addEventListener("click", (e) => {
    closePreModal(e, preorderModalMessage, preorderModalOverlay);
  });

  preorderModalOverlay.addEventListener("click", (e) => {
    closePreModal(e, preorderModalMessage, preorderModalOverlay);
  });
}
